import { render, staticRenderFns } from "./StyleDialogStyleTab.vue?vue&type=template&id=fb336fa6&scoped=true&"
import script from "./StyleDialogStyleTab.vue?vue&type=script&lang=js&"
export * from "./StyleDialogStyleTab.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialogStyleTab.vue?vue&type=style&index=0&id=fb336fa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb336fa6",
  null
  
)

export default component.exports